import { v4 as uuidv4 } from "uuid";

export enum PartitionType {
    LEAD = "LEAD",
    REPLICA = "REPLICA",
}

export class Partition {
    logUid: string;
    nodeId?: number;
    offset: { [index in string]: number } = {};
    active = true;
    type?: PartitionType;

    constructor(public id: number) {
        this.logUid = uuidv4();
    }
}
